import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "watch" }

import { watch, reactive, withDefaults, onUnmounted, ref } from 'vue';
import { Bar } from '@antv/g2plot';
import type { Watch } from '../types';


const __default__ = {
  name: 'watchChar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: { default: () => ({
      vid: 0,
      doc: 0,
      pic: 0,
      used: 0,
      unused: 0,
      total: 0,
      status: 0,
    }) }
  },
  setup(__props: any) {

const props = __props as { dataSource: Watch };


const watchData = reactive([
  {
    name: '未使用',
    value: 0,
    type: '使用情况',
  },
  {
    name: '已使用',
    value: 0,
    type: '使用情况',
  },
]);
const bar = ref<Bar>();
const charRender = () => {
  bar.value = new Bar('watch', {
    data: watchData,
    // isPercent: true,
    isStack: true,
    xField: 'value',
    yField: 'type',
    seriesField: 'name',
    padding: [-45, 0, 0, 0],
    height: 60,
    xAxis: false,
    yAxis: false,
    minBarWidth: 20,
    maxBarWidth: 20,
    // 自定义颜色 绿 黄 蓝 灰
    color: ['#00CCB0', '#F0F2F5'],
    legend: {
      position: 'bottom-left',
      // offsetY: 10,
      marker: {
        symbol: 'circle',
      },
    },
  });

  bar.value.render();
};
watch(props.dataSource, () => {
  const data = props.dataSource;
  watchData[0].value = data.unused;
  watchData[1].value = data.used;
  charRender();
});
onUnmounted(() => {
  bar.value && bar.value.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})